import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import saveCompleteAppointment from '../api/saveCompleteAppointment';
import saveCancelAppointment from '../api/saveCancelAppointment';

const statusNames = {
  pending: 'Pendiente',
  completed: 'Completada',
  canceled_by_doctor: 'Cancelada por doctor',
  canceled_by_user: 'Cancelada por usuario'
};

export default function useAppointmentDetails(appointment, onSuccessfulSave, selectionMode) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorBody, setErrorBody] = useState('');
  const [successBody, setSuccessBody] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    watch,
    // control,
    reset,
    setValue
  } = useForm();

  useEffect(() => {
    reset({ ...appointment, statusName: statusNames[appointment.statusName] });
  }, [appointment, reset]);

  const _createErrorMessage = (errorMessage) => {
    setShowErrorModal(true);
    setErrorBody(errorMessage);
  };

  const closeErrorMessage = () => {
    setShowErrorModal(false);
    setErrorBody('');
  };

  const _createSuccessMessage = (successMessage) => {
    setShowSuccessModal(true);
    setSuccessBody(successMessage);
  };

  const onCloseSuccessMessage = () => {
    setShowSuccessModal(false);
    setSuccessBody('');
    onSuccessfulSave();
  };

  const onSaveComplete = async (data) => {
    if (data.doctorNotes && data.doctorNotes !== '') {
      const executeSaveComplete = await saveCompleteAppointment({
        idAppointment: data.apptID,
        doctorNotes: data.doctorNotes
      });

      if (executeSaveComplete) {
        _createSuccessMessage('¡Se ha actualizado el registro con éxito!');
      }
    }
  };

  const onSaveCancel = async (data) => {
    if (data.doctorNotes && data.doctorNotes !== '') {
      const executeSaveComplete = await saveCancelAppointment({
        idAppointment: data.apptID,
        cancelInstructions: data.doctorNotes,
        idDoctorUser: appointment.idDoctorUser
      });

      if (executeSaveComplete) {
        _createSuccessMessage('¡Se ha actualizado el registro con éxito!');
      }
    }
  };

  const onSaveSubmit = (data) => {
    if (selectionMode === 'complete') {
      onSaveComplete(data);
      return;
    }

    if (selectionMode === 'cancel') {
      onSaveCancel(data);
      return;
    }

    _createErrorMessage('No fue posible enviar los datos. Por favor inténtelo de nuevo.');
  };

  return {
    register,
    handleSubmit,
    errors,
    watch,
    reset,
    setValue,
    isDirty,
    closeErrorMessage,
    onCloseSuccessMessage,
    showSuccessModal,
    showErrorModal,
    errorBody,
    successBody,
    onSaveComplete,
    onSaveCancel,
    onSaveSubmit
  };
}
